module.exports = __webpack_public_path__ + "static/img/qzone.ccae8791.png";